import { Component, inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IxParentDTO } from 'ix-ng-components';
import { IxNgErrorHandlingService } from 'ix-ng-forms';
import { API_BASE_URL } from 'arsktrp-shared-components';

import { PostavitevDTO } from './postavitev-info.model';

@Component({
  selector: 'lib-postavitev-info',
  templateUrl: './postavitev-info.component.html',
  styleUrl: './postavitev-info.component.scss',
})
export class PostavitevInfoComponent implements OnInit {
  private http = inject(HttpClient);
  private ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
  private apiBaseUrl = inject(API_BASE_URL);

  public serviceUrl = `${this.apiBaseUrl}/postavitevInfo`;
  public barva: string | undefined | null = null;
  public besedilo: string | undefined | null = null;

  ngOnInit() {
    this.read();
  }

  read() {
    this.http.get<IxParentDTO<PostavitevDTO>>(`${this.serviceUrl}/readPostavitev`).subscribe({
      next: (data) => {
        this.barva = data.row?.barva;
        this.besedilo = data.row?.besedilo;
      },
      error: this.ixNgErrorHandlingService.handleReadSubscriptionError(
        `Napaka pri GET poizvedbi ${this.serviceUrl}/readPostavitev`,
      ),
    });
  }
}
